import {z} from '@hono/zod-openapi';

import {isNil} from 'ramda';

const LANGUAGE_SUBTAG = /^[a-z]{2,3}$/;
const ADDITIONAL_SUBTAG = /^[A-Za-z0-9]{2,8}$/;
const MAX_ADDITIONAL_SUBTAGS = 2;

export const composeMessageLocaleSchema = z
  .string()
  .max(32)
  .refine(
    (value) => {
      const [language, ...additionalSubtags] = value.split(/[-_]/);
      return (
        !isNil(language) &&
        LANGUAGE_SUBTAG.test(language) &&
        additionalSubtags.length <= MAX_ADDITIONAL_SUBTAGS &&
        additionalSubtags.every((subtag) => ADDITIONAL_SUBTAG.test(subtag))
      );
    },
    {message: 'Expected a locale tag such as cs-CZ'}
  )
  .openapi('ComposeMessageLocale');
